import BaseService from './BaseService'
import config from './../config/index'

class WhatsAppService extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl)
    this.loadScript()
  }

  loadScript() {
    // documentation for referance - https://developers.facebook.com/docs/whatsapp/embedded-signup/embed-the-flow
    if (window.fbAsyncInit !== undefined) {
      return
    }

    window.fbAsyncInit = function () {
      FB.init({
        appId: config.whatsappMetaAppId,
        cookie: true,
        xfbml: true,
        version: config.whatsappMetaAppVersion,
      })
    };

    // Load the JavaScript SDK asynchronously
    (function (d, s, id) {
      let js,
        fjs = d.getElementsByTagName(s)[0]
      if (d.getElementById(id)) return
      js = d.createElement(s)
      js.id = id
      js.src = "https://connect.facebook.net/en_US/sdk.js"
      fjs.parentNode.insertBefore(js, fjs)
    })(document, "script", "facebook-jssdk")
  }

  isConfigured = (locationId: string) =>
    this.requests.get(
      `/location/${locationId}/is-configured`
    )
  companyHasWallet = (companyId: string) =>
    this.requests.get(
      `/company/${companyId}/has-wallet`
    )
  onboard = (data: {locationId: string, companyId: string, inputToken: string, options: object}) =>
    this.requests.post(
      '/onboard',
      {
        locationId: data.locationId,
        companyId: data.companyId,
        inputToken: data.inputToken
      },
      data.options
    )
  resync = (data: {locationId: string}) =>
    this.requests.put(
      `/location/${data.locationId}/resync`,
      {}
    )
  delete = (data: {locationId: string}) =>
    this.requests.delete(
      `/location/${data.locationId}/delete`,
      {}
    )
  getAccountInfo = (data: {locationId: string}) =>
    this.requests.get(
      `/location/${data.locationId}/account-info`,
      {}
    )
  getWhatsAppPhoneNumbersForLocationId = (locationId: string) =>
    this.requests.get(
      `/location/${locationId}/phone-numbers`
    )
  makeDefaultPhoneNumber = (locationId: string, phoneNumberId: string) =>
    this.requests.put(
      `/location/${locationId}/phone-numbers/${phoneNumberId}/default`,
      {}
    )
  getWhatsAppTemplatesForLocationId = (locationId: string) =>
    this.requests.get(
      `/location/${locationId}/template`
    )
  createWhatsAppTemplateForLocationId = (locationId: string, data: any) =>
    this.requests.post(
      `/location/${locationId}/template`,
      data
    )
  updateWhatsAppTemplateForLocationId = (locationId: string, templateId: string, data: any, templateName?: string) =>
    this.requests.post(
      `/location/${locationId}/template/${templateId}`,
      {
        templateName: templateName,
        components: data
      }
    )
  deleteWhatsAppTemplateForLocationId = (locationId: string, templateId: string, templateName: string) =>
    this.requests.delete(
      `/location/${locationId}/template/${templateId}/${templateName}`,
    )
  getProduct = () =>
    this.requests.get(
      '/reselling/product',
    )
  getCompanyResellingConfiguration = (companyId: string) =>
    this.requests.get(
      `/company/${companyId}/reselling/configuration`
    )
  updateCompanyResellingConfiguration = (companyId: string, data: { amount: number }) =>
    this.requests.put(
      `/company/${companyId}/reselling/configuration`,
      data
    )
  getLocationResellingConfiguration = (locationId: string) =>
    this.requests.get(
      `/location/${locationId}/reselling/configuration`
    )
  updateLocationResellingConfiguration = (locationId: string, data: { amount?: number, offeringEnabled?: boolean }) =>
    this.requests.put(
      `/location/${locationId}/reselling/configuration`,
      data
    )
  getCompanySubscriptions = (companyId: string) =>
    this.requests.get(
      `/company/${companyId}/reselling/subscription`
    )
  getLocationSubscriptions = (locationId: string) =>
    this.requests.get(
      `/location/${locationId}/reselling/subscription`
    )
  locationSub = (locationId: string, data) =>
    this.requests.post(
      `/location/${locationId}/reselling/subscription`,
      data
    )
  getAttachement = (locationId: string, messageId: string) =>
    this.requests.get(
      `/location/${locationId}/messages/${messageId}/attachment`, {
        responseType: 'blob'
      }
    )
  postAttachement = (locationId: string, data) =>
    this.requests.post(
      `/location/${locationId}/attachment`, data
    )
}

export const whatsAppService = new WhatsAppService(config.ghlRevexBackendWhatsAppBaseUrl)

export default {}
